import script from "./RegisterEmailForce.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterEmailForce.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterEmailForce.vue?vue&type=style&index=0&id=1c302cf3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c302cf3"]])

export default __exports__